import {
    createApp
} from 'vue'
import App from './App.vue';
import router from './router'
import VueCookies from 'vue-cookies'
import ElementPlus from 'element-plus';
import JsonViewer from "vue3-json-viewer"
import 'element-plus/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import store from './store/index.js'


// element-plus国际化，若不引入，部分组件为英文
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'


const app = createApp(App).use(router)


app.use(store.store)
app.use(ElementPlus, {
    locale
})
app.use(router)
app.use(JsonViewer)
app.mount('#app')

app.config.warnHandler = () => null; //关闭Vue warn
app.config.globalProperties.echarts = echarts;
app.config.globalProperties.$cookies = VueCookies;

app.config.globalProperties.order = 0 //未填数量
//app.config.globalProperties.errors = [] //错误提示

//状态
app.config.globalProperties.stateName = function () {
    return ["未导入", "已导入", "审核成功", "退回", "待审", "已经发布"]
}
//增加提示
app.config.globalProperties.addOrSet = function (key, msg) {
    if (msg == undefined || msg == null) {
        msg = key
    }

    let e = this.$store.state.errors.find(e => e.key == key)
    if (e)
        e.message = msg
    else
        this.$store.commit('changeAddError', { key: key, message: msg })
    /*let e = this.errors.find(e => e.key == key)
    this.errors.push({
        key: key,
        message: msg,
    })*/
}
//删除提示
app.config.globalProperties.remove = function (key) {
    this.$store.commit('changeRemoveError', key)
    /*let idx = this.errors.findIndex(e => e.key == key)
    if (idx > -1)
        this.errors.splice(idx, 1)*/
}
//尽可能将v转换为数值，无法转换时返回defaultValue
app.config.globalProperties.num = function (v, defaultValue = 0) {
    if (v && v != "") {
        v = String(v).replace(/,/g, "").replace(/\s*/g, "")
        if (!isNaN(v))
            return +parseFloat(Number(v).toPrecision(15))
    }
    return defaultValue
}
//尽可能将v转换为数值，如果不是数字类型，转化为原值
app.config.globalProperties.tableNum = function (v) {
    if (v && v != "") {
        v = String(v).replace(/,/g, "").replace(/\s*/g, "")
        if (!isNaN(v))
            return parseFloat(Number(v).toPrecision(15)).toFixed(2)
    }
    return v

}
//千分符格式化
app.config.globalProperties.numFormat = function (num) {
    var res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return $1 + ",";
        });
    })
    return res;
}
//去除千分符
app.config.globalProperties.thousand = function (num) {
    if (num == undefined || num == null) {
        num = 0;
    }
    num = num.toString();
    num = num.replace(/[ ]/g, ""); //去除空格  
    num = num.replace(/,/gi, '');
    return Number(num);
}
//是否是整数
app.config.globalProperties.isInteger = function (val) {
    var countreg = /^[1-9]\d*$/;
    if (!val || val == "0") {
        return 0;
    } else {
        val = Math.floor(this.num(val)); //取整
        if (!countreg.test(val)) { //非数字
            return 0;
        } else {
            return this.numFormat(val);
        }
    }
}
//是否是金额
app.config.globalProperties.isMoney = function (val) {
    if (val != "" && val != null && !isNaN(this.num(val))) {
        //是整数
        if (Math.floor(this.num(val)) == this.num(val)) {
            val = String(val)
            return this.numFormat(this.num(val));
        } else {
            //是小数
            if (String(val).indexOf(".") != -1) {
                val = this.num(val).toFixed(2);
                return this.numFormat(this.num(val));
            } else {
                return;
            }
        }
    } else {
        return 0;
    }
}
//判断字符串是否为空 空=>true 非空=>false
app.config.globalProperties.isEmptyStr = function (val) {
    if (!val && val != 0) {
        return true
    } else if (typeof (val) != 'string') {
        return false
    } else if (typeof (val) == 'string' && val.replace(/\s*/g, "") == "") {
        return true
    } else {
        return false
    }
}
app.config.globalProperties.pickOneOf = function (a, b) {
    if (this.isEmptyStr(a))
        return b
    return a
}
//尝试转换为数值
app.config.globalProperties.num2 = function num2(v) {
    if (v === null || v === undefined) {
        throw v + '无法转换为数值'
    }

    function num(v, defaultValue = 0, precision = 15) {
        if (v && v != "") {
            v = String(v).replace(/,/g, "").replace(/\s*/g, "")
            if (!isNaN(v))
                return +parseFloat(Number(v).toPrecision(precision))
        }
        return defaultValue
    }
    return num(v, 0)
}
//删除空格
app.config.globalProperties.compact = function compact(text) {
    var re = /[ \0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;
    return text.toString().replace(re, "").trim();
}
//参数被强制转换为数值
app.config.globalProperties.growthValueText = function (now, before = 0) {
    var text = ""
    if (now || now == 0) {
        text += this.num(now) >= this.num(before) ? "增加" : "减少"
        text += this.numFormat(this.num(Math.abs(this.num(now) - this.num(before)).toFixed(2)))
    }
    return text
}

//参数被强制转换为数值，然后返回增长率的描述文本。
app.config.globalProperties.growthRatioText = function (now, before = 0) {
    var text = ""
    if (now || now == 0) {
        var value = Math.abs(this.num(now) / this.num(before) - 1)
        text += this.num(now) >= this.num(before) ? "增长" : (this.$cookies.get("district") == "江苏" ? "减少" : "下降")
        if (value == Infinity) {
            text += "100%"
        } else {
            text += this.numFormat(this.num((value * 100).toFixed(2)))
            text += this.num((value * 100).toFixed(2)) == 0 ? (now != before && now > 0 ? "%（该占比四舍五入后为0%）" : "%") : "%"
        }
    }
    return text
}
//参数被强制转换为数值，比率数字。
app.config.globalProperties.growthRatioNum = function (now, before = 0) {
    var text = ""
    if (now || now == 0) {
        var value = Math.abs(this.num(now) / this.num(before) - 1)
        if (value == Infinity) {
            text += "100%"
        } else {
            text += this.num((value * 100).toFixed(2))
        }
    }
    return text
}
//计算占比。
app.config.globalProperties.calcRatio = function (now, before = 0) {
    var text = ""
    if (now == 0) {
        return 0 + "%"
    } else if (now) {
        var value = Math.abs(this.num(now) / this.num(before))
        if (value == Infinity) {
            text += "100%"
        } else {
            var value = this.num((value * 100).toFixed(2))
            text += this.numFormat(value)
            if (value == 0) {
                text += this.num(now) > 0 ? "%（该占比四舍五入后为0%）" : "%"
            } else if (value == 100) {
                text += this.num(now) == this.num(before) ? "%" : "%（该占比四舍五入后为100%）"
            } else {
                text += "%"
            }
        }
    } else {
        return 0 + "%"
    }
    return text
}
//valueList要计算的数组
//idx要计算数组中值的下表
//precision百分比保留几位小数
app.config.globalProperties.getPercentValue = function (valueList, idx, precision) {
    // 判断是否为空
    if (!valueList[idx]) {
        return 0 + "%";
    }
    // 求和
    let sum = valueList.reduce(function (acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) {
        return 0 + "%";
    }
    // 10的2次幂是100，用于计算精度。
    let digits = Math.pow(10, precision);
    // 扩大比例100，
    let votesPerQuota = valueList.map(function (val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    // 总数，扩大比例意味的总数要扩大
    let targetSeats = digits * 100;
    // 再向下取值，组成数组
    let seats = votesPerQuota.map(function (votes) {
        return Math.floor(votes);
    });
    // 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
    let currentSum = seats.reduce(function (acc, val) {
        return acc + val;
    }, 0);
    // 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
    let remainder = votesPerQuota.map(function (votes, idx) {
        return votes - seats[idx];
    });
    // 给最大最大的余额加1，凑个占比100%；
    while (currentSum < targetSeats) {
        //  找到下一个最大的余额，给其加1
        let max = Number.NEGATIVE_INFINITY;
        let maxId = null;
        for (let i = 0, len = remainder.length; i < len; ++i) {
            if (remainder[i] > max) {
                max = remainder[i];
                maxId = i;
            }
        }
        // 对最大项余额加1
        ++seats[maxId];
        // 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
        remainder[maxId] = 0;
        // 总的也要加1，为了判断是否总数是否相同，跳出循环。
        ++currentSum;
    }
    if ((seats[idx] / digits) == 100) {
        if (valueList[idx] == sum) {
            return (seats[idx] / digits) + "%"
        } else {
            return (seats[idx] / digits) + "%（该占比四舍五入后为100%）"
        }
    } else if ((seats[idx] / digits) == 0) {
        if (valueList[idx] > 0) {
            return (seats[idx] / digits) + "%（该占比四舍五入后为0%）"
        } else {
            return (seats[idx] / digits) + "%"
        }
    } else {
        return this.numFormat(this.num((seats[idx] / digits).toFixed(2))) + "%"
    }

    // 这时候的seats就会总数占比会100%
    //return (seats[idx] / digits) == 100 || (seats[idx] / digits) == 0 ? (seats[idx] / digits) : (seats[idx] / digits).toFixed(2);
}
app.config.globalProperties.mesTableConfig = function mesTableConfig(tableContentgo, detailIndexgo, headertablego, thisConfiggo, emalertgo, btypego) {
    let renderData = ''
    if (tableContentgo) {
        let tablemes1 = `var tableContent= ${JSON.stringify(tableContentgo)};`
        //let tablemes2 = `var tableDataConfig= ${JSON.stringify(tableDataConfiggo)};`
        let tablemes2 = `var detailIndex= ${JSON.stringify(detailIndexgo)};`
        let tablemes3 = `var headertable= ${JSON.stringify(headertablego)};`
        let tablemes4 = `var thisConfig= ${JSON.stringify(thisConfiggo)};`
        let tablemes5 = `var emalert= ${JSON.stringify(emalertgo)};`
        let tablemes6 = `var btype= ${JSON.stringify(btypego)};`
        renderData = tablemes1 + tablemes2 + tablemes3 + tablemes4 + tablemes5 + tablemes6
    }
    return renderData;
}
app.config.globalProperties.makeEnvCode = function (tables) {
    function getPureName(text) {
        let idx = text.indexOf('、')
        return text.substr(idx + 1)
    }
    let type = this.pickOneOf(this.$store.state.openType, 'js')
    let year = this.pickOneOf(this.$store.state.openYear, '2020')
    let program = "";
    program += `let getPureName= ${getPureName.toString()};`;
    program += `let num= ${this.num.toString()};`;
    program += `let num2= ${this.num2.toString()};`;
    program += `let compact= ${this.compact.toString()};`;
    if (tables) {
        //山东20决算特殊需求
        var tableNum = tables.filter(e => e.type == type && e.year == year).length
        let sent10 = ''
        if (this.$cookies.get("district") == "山东" && type == "js" && year == 2020) {
            if (tables.filter(e => e.name == '10' && e.type == "js" && e.year == 2020).length > 0) {
                sent10 = `var t10= ${JSON.stringify((tables.find(e => e.name == '10' && e.type == "js" && e.year == 2020) || { rows: [] }).rows)};`;
            }
            tableNum = 9
        } else if (type == "js" && Number(year) == 2021) {
            tableNum = 14
        } else if (this.$cookies.get("district") == "浙江") {
            tableNum = 10
        }else {
            tableNum = 12
        }
        //2020决算有
        let sent4 = `var yxb= ${JSON.stringify((tables.find(e => e.type == "运行表" && e.year == 2020) || { rows: [] }).rows)};`;
        let sent5 = `var yxb2= ${JSON.stringify((tables.find(e => e.type == "运行表" && e.year == 2021) || { rows: [] }).rows)};`;
        program += sent10;
        program += sent4;
        program += sent5;
        for (let i = 1; i <= tableNum; i++) {
            let sent1 = `var t${i}= ${JSON.stringify((tables.find(e => e.name == i && e.type == type && e.year == year) || { rows: [] }).rows)};`;
            let sent2 = `var t${i}_last= ${JSON.stringify((tables.find(e => e.name == i && e.type == type && e.year == (year - 1)) || { rows: [] }).rows)};`;
            let sent3 = `var t${i}_ys= ${JSON.stringify((tables.find(e => e.name == i && e.type == "ys" && e.year == year) || { rows: [] }).rows)};`;
            program += sent1;
            program += sent2;
            program += sent3;
        }
    }
    return program;
}

app.config.globalProperties.intToChinese = function (str) {
    str = str + '';
    var len = str.length - 1;
    var idxs = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
    var num = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    //var num = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
        var pos = 0;
        if ($1[0] != '0') {
            pos = len - idx;
            if (idx == 0 && $1[0] == 1 && idxs[len - idx] == '十') {
                return idxs[len - idx];
            }
            return num[$1[0]] + idxs[len - idx];
        } else {
            var left = len - idx;
            var right = len - idx + $1.length;
            if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
                pos = left - left % 4;
            }
            if (pos) {
                return idxs[pos] + num[$1[0]];
            } else if (idx + $1.length >= len) {
                return '';
            } else {
                return num[$1[0]]
            }
        }
    });
}

app.config.globalProperties.charts = function (el, name, data) {
    let myChart = this.echarts.init(el);
    // 绘制图表
    let that = this
    myChart.setOption({
        animation: false,
        title: {
            text: name,
            left: 'center'
        },
        textStyle: {
            fontSize: 10,
            fontFamily: "Microsoft YaHei"
        },
        tooltip: {
            trigger: 'item',
            formatter: function (a) {
                return a.data.name + '\n' + that.isMoney(a.data.value) + '万元\n(' + that.isMoney(a.percent) + "%)";
            },
        },
        legend: {
            orient: 'horizontal',
            left: 'left',
            bottom: 'bottom',
            width: 'auto',
        },
        series: [
            {
                type: 'pie',
                radius: '50%',
                center: ['50%', data.length > 7 ? '42%' : '50%'],
                data: data,
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                label: {
                    formatter: function (a) {
                        return a.data.name + '\n' + that.isMoney(a.data.value) + '万元' + (that.$cookies.get("district") == "江苏" ? "占(" : "(占") + that.isMoney(a.percent) + "%)";
                    },
                }
            }
        ]
    });
}
app.config.globalProperties.barChart = function (el, name, data) {
    let myChart = this.echarts.init(el);
    let that = this;
    let year = this.$store.state.openYear
    // 绘制图表
    myChart.setOption({
        animation: false,
        title: {
            text: name,
            x: 'center',
            textStyle: {
                fontSize: 22,
                fontFamily: '微软雅黑,Arial',
            },
        },
        tooltip: {},
        legend: {
            left: 'left',
            bottom: 'bottom',
            data: [`${year - 1}年`, `${year}年`]
        },
        xAxis: {
            data: [`${year - 1}年`, `${year}年`]
        },
        yAxis: {},
        series: [{
            name: `${year - 1}年`,
            type: 'bar',
            data: [{
                value: data[0],
            }],
            label: {
                color: '#000',
                textStyle: { fontSize: 18, },
                position: 'top',
                show: true,
                formatter: function (a) {
                    return that.isMoney(a.data.value) + '万元';
                },
            },
            labelLine: { show: true },
            barGap: '-100%',
            barWidth: '100',
        }, {
            name: `${year}年`,
            type: 'bar',
            data: ['', {
                value: data[1],
            }],
            label: {
                color: '#000',
                textStyle: { fontSize: 18, },
                position: 'top',
                show: true,
                formatter: function (a) {
                    return that.isMoney(a.data.value) + '万元';
                },
            },
            labelLine: { show: true },
            barGap: '-100%',
            barWidth: '100',
        }]
    });
}
// 转换时间格式
app.config.globalProperties.conversionTime = function (datetime) {
    function addDateZero(num) {
        return (num < 10 ? '0' + num : num)
    }
    const d = new Date(datetime)
    const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate())
    return formatdatetime
},
//转换时间格式 加上时分秒
app.config.globalProperties.conversionTimeformaDate = function (datetime) {
    function addDateZero(num) {
        return (num < 10 ? '0' + num : num)
    }
    const d = new Date(datetime)
    const formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    return formatdatetime
}


